import * as React from 'react';
import Select from 'react-select';

import { IConditionError } from '../../../../../interface/conditions.interface';
import ConditionRule from '../conditionRule';
import { AddRuleButton, EditDeleteButtons } from '../ConditionCommon';
import IndicatorsContainer from '../../../../common/reactSelect/IndicatorsContainer';
import {
    PreCondition,
    PostCondition,
    QuestionSummary,
    QuestionID
} from '@nexxt/common/types';
import HealthIcon from '../../../../common/designElements/HealthIcon';
import Option from '../../../../common/reactSelect/Option';
export interface PrePostConditionProps {
    prepost: boolean;
    index: number;
    condition: PreCondition | PostCondition;
    filteredQuestionSummaries: QuestionSummary[];
    flattenQuestionSummaries: QuestionSummary[];
    questions: { [key: number]: QuestionSummary };
    editIndex: number;
    ruleEditIndex: number;
    errorObject: IConditionError;
    editEnabled: boolean;
    healthCondition: any;
    currentQuestionId: QuestionID;
    onDone: () => void;
    onCancel: () => void;
    onQuestionSelect: (index: number) => (question: any) => void;
    onAnswerTypeSelect: (index: number) => (answerType: any) => void;
    onValueChange: (index: number) => (type, value, options) => void;
    onEdit: () => void;
    onDelete: () => void;
    onAddRule: () => void;
    onEditRule: (ruleIndex) => () => void;
    onDestinationQuestionSelect?: (question: any) => void;
    onSaveRule: (index: number, type: string) => () => void;
    onDeleteRule: (index: number) => () => void;
    onCancelAddRule: () => void;
}

const PrePostCondition: React.SFC<PrePostConditionProps> = ({
    index,
    condition,
    ruleEditIndex,
    prepost,
    healthCondition,
    ...props
}: PrePostConditionProps) => {
    const type = prepost ? 'IPreCondition' : 'postcondition';
    const selectedDestinationQ =
        !prepost && (condition as PostCondition).destinationQ
            ? props.questions[(condition as PostCondition).destinationQ.value]
            : null;

    const health = healthCondition && healthCondition.list[0];
    const healthType = healthCondition && healthCondition.type;

    return (
        <div className="accordion conditions-accordion" id="accordionExample">
            <div className="card">
                <div className="card-header">
                    <div className="card-header__title">
                        {prepost ? 'Pre-condition' : 'Post-condition'} #
                        {index + 1}
                        <HealthIcon
                            active={
                                health &&
                                health.conditionRefs.includes(
                                    condition.conditionID
                                )
                            }
                            type={healthType}
                            className={`card-header__health ${healthType?.toLowerCase()}`}
                            questionID={`condition--${condition.conditionID}`}
                            message={health && health.message}
                        />
                        <EditDeleteButtons
                            onEdit={props.onEdit}
                            onDelete={props.onDelete}
                            show={props.editIndex !== index}
                            ruleId={`${type}-${index}${condition.conditionID}`}
                            disabled={!props.editEnabled}
                        />
                    </div>
                </div>
                <div
                    className="show"
                    id="collapseOne"
                    aria-labelledby="headingOne"
                    data-parent="#accordionExample"
                >
                    <div className="card-body accordion-content">
                        <p className="helper">
                            Rules: If all the rules below are met, then this
                            condition will be true and this question will be
                            shown to the user.
                        </p>
                        {condition.rules.map((rule, ruleIndex) => {
                            return (
                                <React.Fragment key={ruleIndex}>
                                    <ConditionRule
                                        isEdit={ruleEditIndex === ruleIndex}
                                        isConditionEdit={
                                            props.editIndex === index
                                        }
                                        onAnswerTypeSelect={props.onAnswerTypeSelect(
                                            ruleIndex
                                        )}
                                        onEditRule={props.onEditRule(ruleIndex)}
                                        onDeleteRule={props.onDeleteRule(
                                            ruleIndex
                                        )}
                                        onQuestionSelect={props.onQuestionSelect(
                                            ruleIndex
                                        )}
                                        onValueChange={props.onValueChange(
                                            ruleIndex
                                        )}
                                        questionSummaries={
                                            props.filteredQuestionSummaries
                                        }
                                        onSaveRule={props.onSaveRule(
                                            ruleIndex,
                                            type
                                        )}
                                        rule={rule}
                                        type={type}
                                        errorObject={
                                            props.errorObject &&
                                            props.errorObject[ruleIndex]
                                        }
                                        key={ruleIndex}
                                        index={ruleIndex}
                                        onCancelAddRule={props.onCancelAddRule}
                                        editEnabled={props.editEnabled}
                                        currentQuestionId={
                                            props.currentQuestionId
                                        }
                                    />
                                    {ruleIndex < condition.rules.length - 1 ? (
                                        <span className="rule__separator">
                                            and (&amp;)
                                        </span>
                                    ) : null}
                                </React.Fragment>
                            );
                        })}
                        <AddRuleButton
                            onAddClick={props.onAddRule}
                            hide={
                                ruleEditIndex > -1 || props.editIndex !== index
                            }
                            disabled={!props.editEnabled}
                        />
                        {!prepost && (
                            <div className="form-group col-md-12">
                                <label className="form-group__label form-group__label--block">
                                    Then, jump to
                                </label>
                                <Select
                                    className={
                                        'form-select--react-select react-select'
                                    }
                                    isDisabled={
                                        props.editIndex !== index ||
                                        !props.editEnabled
                                    }
                                    // menuIsOpen={true}
                                    classNamePrefix="react-select"
                                    value={selectedDestinationQ}
                                    options={props.flattenQuestionSummaries}
                                    onChange={props.onDestinationQuestionSelect}
                                    col="col-md-12"
                                    components={{
                                        Option,
                                        IndicatorsContainer
                                    }}
                                />
                            </div>
                        )}
                        {props.editIndex === index ? (
                            <div className="btn-wrapper">
                                <button
                                    className="btn btn--sm btn--transparent"
                                    onClick={props.onCancel}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn--sm btn--green"
                                    onClick={props.onDone}
                                    disabled={!props.editEnabled}
                                >
                                    Done
                                </button>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrePostCondition;
